import { languageIdBus } from "@/event/languageIdBus"
import { productBus } from "@/event/product/productBus"
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy"
import type { Option } from "@/storage/products"
import { getOptionValueNameById } from "@/utils/product/getOptionValueNameById"
import type { Ref } from "vue"

export function incrementOptionValueHappy(optionValueId: number,
    optionId: number,
    maxQuantity: number,
    counterOptionValue: Ref<number>,
    option: Option
) {
    if (
        maxQuantity &&
        counterOptionValue.value >= maxQuantity &&
        productBus.value?.options
    ) {
        return
    }

    const optionFound = productBus.value?.options.find((e) => e.option_id === optionId)
    if (!optionFound) return

    const freeOptionCount = optionFound.free_option_count || 0
    const maxOptionCount = optionFound.max_option_count || 0

    const optionValueFind = optionFound?.values.find(
        (e) => e.option_value_id === optionValueId
    )
    if (!optionValueFind) return

    counterOptionValue.value++

    if (optionValueFind && optionFound) {
        if (optionFound.type === 'select' || optionFound.type === 'checkbox') {
            const selectedvalueFree =
                selectOptionsListHappy.value[optionId].selected_values.checkbox_option
                    .option_value_free
            const selectedvaluePaid =
                selectOptionsListHappy.value[optionId].selected_values.checkbox_option
                    .option_value_paid

            if (optionValueFind.reset === 1) {
                const keepOptionsFree = selectedvalueFree.filter(
                    (ov) => ov.option_value_grup !== optionValueFind.grup
                )
                const keepOptionsPaid = selectedvaluePaid.filter(
                    (ov) => ov.option_value_grup !== optionValueFind.grup
                )

                selectOptionsListHappy.value[
                    optionId
                ].selected_values.checkbox_option.option_value_free = keepOptionsFree
                selectOptionsListHappy.value[
                    optionId
                ].selected_values.checkbox_option.option_value_paid = keepOptionsPaid
            } else {
                const existingReset = [...selectedvalueFree, ...selectedvaluePaid].find(
                    (item) =>
                        item.option_value_reset &&
                        item.option_value_grup === optionValueFind.grup
                )

                if (existingReset) {
                    const freeIndex = selectedvalueFree.findIndex(
                        (item) => item.option_value_id === existingReset.option_value_id
                    )
                    if (freeIndex !== -1) {
                        selectedvalueFree.splice(freeIndex, 1)
                    }

                    const paidIndex = selectedvaluePaid.findIndex(
                        (item) => item.option_value_id === existingReset.option_value_id
                    )

                    if (paidIndex !== -1) {
                        selectOptionsListHappy.value[
                            optionId
                        ].selected_values.checkbox_option.option_value_paid.splice(
                            paidIndex,
                            1
                        )
                    }
                    selectOptionsListHappy.value[
                        optionId
                    ].selected_values.checkbox_option.quantity_free = freeOptionCount
                    selectOptionsListHappy.value[
                        optionId
                    ].selected_values.checkbox_option.quantity_paid =
                        maxOptionCount - freeOptionCount
                }
            }

            const oneIsFree = selectedvalueFree.findIndex(
                (i) => i.option_value_one_is_free === true
            )

            if (oneIsFree !== -1) {
                const [oneIsFreeItem] = selectOptionsListHappy.value[
                    optionId
                ].selected_values.checkbox_option.option_value_free.splice(oneIsFree, 1)

                const oneIsFreeFound = option.values.find(
                    (i) => i.option_value_id === oneIsFreeItem.option_value_id
                )
                if (!oneIsFreeFound) return

                const currentOptionAdded = {
                    option_value_id: oneIsFreeFound?.option_value_id,
                    option_value_name: getOptionValueNameById(
                        oneIsFreeFound.option_value_id,
                        languageIdBus.value
                    ),
                    option_value_image: oneIsFreeFound.image,
                    option_value_price: oneIsFreeFound.ov_price,
                    option_value_reset: oneIsFreeFound.reset,
                    option_value_grup: oneIsFreeFound.grup,
                    option_value_one_is_free: true,
                    option_value_special: false
                }

                selectOptionsListHappy.value[
                    optionId
                ].selected_values.checkbox_option.option_value_paid.push(
                    currentOptionAdded
                )
                selectOptionsListHappy.value[optionId].selected_values.checkbox_option
                    .quantity_paid--
                selectOptionsListHappy.value[optionId].selected_values.checkbox_option
                    .quantity_free++
            }

            const quantityFree = Number(
                selectOptionsListHappy.value[optionId].selected_values.checkbox_option
                    .quantity_free
            )
            const quantityPaid = Number(
                selectOptionsListHappy.value[optionId].selected_values.checkbox_option
                    .quantity_paid
            )

            switch (optionValueFind.price_status) {
                case 'general':
                    // paid
                    if (quantityFree === 0 && quantityPaid === 0) {
                        const currentOptionAdded = {
                            option_value_id: optionValueFind?.option_value_id,
                            option_value_name: getOptionValueNameById(
                                optionValueFind.option_value_id,
                                languageIdBus.value
                            ),
                            option_value_image: optionValueFind.image,
                            option_value_price: optionValueFind.ov_price,
                            option_value_reset: optionValueFind.reset,
                            option_value_grup: optionValueFind.grup,
                            option_value_one_is_free: false,
                            option_value_special: false
                        }
                        selectOptionsListHappy.value[
                            optionId
                        ].selected_values.checkbox_option.option_value_paid.push(
                            currentOptionAdded
                        )
                    }
                    // paid
                    if (quantityFree === 0 && quantityPaid !== 0) {
                        const currentOptionAdded = {
                            option_value_id: optionValueFind?.option_value_id,
                            option_value_name: getOptionValueNameById(
                                optionValueFind.option_value_id,
                                languageIdBus.value
                            ),
                            option_value_image: optionValueFind.image,
                            option_value_price: optionValueFind.ov_price,
                            option_value_reset: optionValueFind.reset,
                            option_value_grup: optionValueFind.grup,
                            option_value_one_is_free: false,
                            option_value_special: false
                        }
                        selectOptionsListHappy.value[
                            optionId
                        ].selected_values.checkbox_option.option_value_paid.push(
                            currentOptionAdded
                        )
                        selectOptionsListHappy.value[optionId].selected_values
                            .checkbox_option.quantity_paid--
                    }
                    // free => paid
                    if (quantityFree !== 0 && quantityPaid !== 0) {
                        if (selectedvalueFree.length <= quantityFree) {
                            const currentOptionAdded = {
                                option_value_id: optionValueFind?.option_value_id,
                                option_value_name: getOptionValueNameById(
                                    optionValueFind.option_value_id,
                                    languageIdBus.value
                                ),
                                option_value_image: optionValueFind.image,
                                option_value_price: '0',
                                option_value_reset: optionValueFind.reset,
                                option_value_grup: optionValueFind.grup,
                                option_value_one_is_free: false,
                                option_value_special: false
                            }
                            selectOptionsListHappy.value[
                                optionId
                            ].selected_values.checkbox_option.option_value_free.push(
                                currentOptionAdded
                            )
                            selectOptionsListHappy.value[optionId].selected_values
                                .checkbox_option.quantity_free--
                        } else {
                            const currentOptionAdded = {
                                option_value_id: optionValueFind?.option_value_id,
                                option_value_name: getOptionValueNameById(
                                    optionValueFind.option_value_id,
                                    languageIdBus.value
                                ),
                                option_value_image: optionValueFind.image,
                                option_value_price: optionValueFind.ov_price,
                                option_value_reset: optionValueFind.reset,
                                option_value_grup: optionValueFind.grup,
                                option_value_one_is_free: false,
                                option_value_special: false
                            }
                            selectOptionsListHappy.value[
                                optionId
                            ].selected_values.checkbox_option.option_value_paid.push(
                                currentOptionAdded
                            )
                            selectOptionsListHappy.value[optionId].selected_values
                                .checkbox_option.quantity_paid--
                        }
                    }

                    if (quantityFree !== 0 && quantityPaid === 0) {
                        const currentOptionAdded = {
                            option_value_id: optionValueFind?.option_value_id,
                            option_value_name: getOptionValueNameById(
                                optionValueFind.option_value_id,
                                languageIdBus.value
                            ),
                            option_value_image: optionValueFind.image,
                            option_value_price: optionValueFind.ov_price,
                            option_value_reset: optionValueFind.reset,
                            option_value_grup: optionValueFind.grup,
                            option_value_one_is_free: false,
                            option_value_special: false
                        }
                        selectOptionsListHappy.value[
                            optionId
                        ].selected_values.checkbox_option.option_value_free.push(
                            currentOptionAdded
                        )
                        selectOptionsListHappy.value[optionId].selected_values
                            .checkbox_option.quantity_free--
                    }
                    break
                case 'one_is_free':
                    if (selectedvalueFree.length === 0) {
                        const currentOptionAdded = {
                            option_value_id: optionValueFind?.option_value_id,
                            option_value_name: getOptionValueNameById(
                                optionValueFind.option_value_id,
                                languageIdBus.value
                            ),
                            option_value_image: optionValueFind.image,
                            option_value_price: '0',
                            option_value_reset: optionValueFind.reset,
                            option_value_grup: optionValueFind.grup,
                            option_value_one_is_free: true,
                            option_value_special: false
                        }
                        selectOptionsListHappy.value[
                            optionId
                        ].selected_values.checkbox_option.option_value_free.push(
                            currentOptionAdded
                        )
                        selectOptionsListHappy.value[optionId].selected_values
                            .checkbox_option.quantity_free--
                    } else {
                        const currentOptionAdded = {
                            option_value_id: optionValueFind?.option_value_id,
                            option_value_name: getOptionValueNameById(
                                optionValueFind.option_value_id,
                                languageIdBus.value
                            ),
                            option_value_image: optionValueFind.image,
                            option_value_price: optionValueFind.ov_price,
                            option_value_reset: optionValueFind.reset,
                            option_value_grup: optionValueFind.grup,
                            option_value_one_is_free: true,
                            option_value_special: false
                        }
                        selectOptionsListHappy.value[
                            optionId
                        ].selected_values.checkbox_option.option_value_paid.push(
                            currentOptionAdded
                        )
                        selectOptionsListHappy.value[optionId].selected_values
                            .checkbox_option.quantity_paid--
                    }
                    break
                case 'special':
                    const currentOptionAdded = {
                        option_value_id: optionValueFind?.option_value_id,
                        option_value_name: getOptionValueNameById(
                            optionValueFind.option_value_id,
                            languageIdBus.value
                        ),
                        option_value_image: optionValueFind.image,
                        option_value_price: optionValueFind.ov_price,
                        option_value_reset: optionValueFind.reset,
                        option_value_grup: optionValueFind.grup,
                        option_value_one_is_free: false,
                        option_value_special: true
                    }

                    selectOptionsListHappy.value[
                        optionId
                    ].selected_values.checkbox_option.option_value_paid.push(
                        currentOptionAdded
                    )
                    selectOptionsListHappy.value[optionId].selected_values.checkbox_option
                        .quantity_paid--
                    break
            }
        }
    }
}